"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    TableResizeHandle: function() {
        return _index.TableResizeHandle;
    },
    renderTableResizeHandle_unstable: function() {
        return _index.renderTableResizeHandle_unstable;
    },
    tableResizeHandleClassNames: function() {
        return _index.tableResizeHandleClassNames;
    },
    useTableResizeHandleStyles_unstable: function() {
        return _index.useTableResizeHandleStyles_unstable;
    },
    useTableResizeHandle_unstable: function() {
        return _index.useTableResizeHandle_unstable;
    }
});
const _index = require("./components/TableResizeHandle/index");
